import { get, each, throttle } from "lodash";
import { onLargeScreen, onMediumScreen } from "./breakpoint-detect";

declare const jQuery: any;
const $ = jQuery;

interface Replacement
{
	orig: string; // url
	replace: string; // url
	viewport: "s"|"m"|"l";
}

interface ReplacementsByViewport
{
	s?: string; // url
	m?: string; // url
	l?: string; // url
}

export function initAltBgdImages(): void
{
	const data: Replacement[] = get(window, "iw.altBgdImgUrls");
	if (!data || !data.length)
	{
		return;
	}
	const $window = $(window);
	const $els = $(`[data-bgd-image]`);
	$els.each(function () {
		const $el = $(this);
		const origUrl: string = $el.attr("data-bgd-image");
		if (!origUrl)
		{
			return;
		}
		const replacements: ReplacementsByViewport = getReplacementsForUrl(origUrl, data);
		if (!replacements)
		{
			return;
		}
		const replace = () => {
			if (onLargeScreen())
			{
				setBackgroundImageUrl($el, replacements.l || origUrl);
				return;
			}
			if (onMediumScreen())
			{
				setBackgroundImageUrl($el, replacements.m || origUrl);
				return;
			}
			setBackgroundImageUrl($el, replacements.s || origUrl);
		};
		replace();
		$window.on("resize orientationchange load", throttle(replace, 100, { leading: true }))
	});
}

function setBackgroundImageUrl($el, url: string): void
{
	const backgroundImage: string = `url("${url}")`;
	$el.css({ backgroundImage });
}

function getReplacementsForUrl(origUrl: string, data: Replacement[]): ReplacementsByViewport
{
	let retval: ReplacementsByViewport|undefined = undefined;
	each(data, (datum: Replacement) => {
		if (datum.orig !== origUrl)
		{
			return;
		}
		if (!retval)
		{
			retval = {};
		}
		retval[datum.viewport] = datum.replace;
	});
	return retval;
}
